// apps/web/src/components/painel/painel-sem-indicadores.tsx — Fase 16.1 (UI-25, D-18, WR-03); Fase 17.8, Plano 25 (D-20).
// Corpo do painel para a sessão que não vê nenhum bloco (sem painel:consultar nem permissão de área): em vez de uma
// página em branco, o aviso do perfil sem indicadores, com o caminho para o menu. O aviso morava em visao-geral-conteudo
// (removido junto do painel legado da 16.1); aqui ele é o único dono.
import type { ReactElement } from 'react';
import { Info } from 'lucide-react';
import { primeiroModuloPermitido } from '../../lib/destino-inicial';
import { Alert } from '../ui/alert';
import { Button } from '../ui/button';

export interface PainelSemIndicadoresProps {
  readonly permissoes: readonly string[];
  /** Abre ou foca a navegação do shell; sem ele o botão vira link para o primeiro módulo do menu. */
  readonly onAbrirMenu?: () => void;
}

export function AvisoSemIndicadores({ permissoes, onAbrirMenu }: PainelSemIndicadoresProps): ReactElement {
  const primeiroModulo = onAbrirMenu ? undefined : primeiroModuloPermitido(permissoes);
  return (
    <Alert role="status" data-testid="painel-visao-geral-vazio">
      <Info aria-hidden="true" />
      <div className="col-start-2 flex min-w-0 flex-col gap-2">
        <p className="min-w-0 break-words text-[length:var(--font-body)] font-semibold leading-[1.4] text-foreground">Seu perfil ainda não tem indicadores no painel.</p>
        <p className="min-w-0 break-words text-[length:var(--font-body)] leading-normal text-muted-foreground">Use o menu para abrir os módulos liberados para você.</p>
        {onAbrirMenu && (
          <Button type="button" variant="outline" size="sm" className="self-start" onClick={onAbrirMenu} data-testid="painel-visao-geral-abrir-menu">
            Abrir menu
          </Button>
        )}
        {primeiroModulo && (
          <Button asChild variant="outline" size="sm" className="self-start">
            <a href={primeiroModulo} data-testid="painel-visao-geral-abrir-menu">Abrir menu</a>
          </Button>
        )}
      </div>
    </Alert>
  );
}

export function PainelSemIndicadores({ permissoes, onAbrirMenu }: PainelSemIndicadoresProps): ReactElement {
  return (
    <div data-testid="painel-sem-indicadores" className="flex min-w-0 flex-col gap-4">
      <AvisoSemIndicadores permissoes={permissoes} onAbrirMenu={onAbrirMenu} />
    </div>
  );
}
